<template>
   <div class="DataUpdate">
      <modal
   name="RolModal"
   width="80%"
   height="auto"
   :scrollable="true"
   :adaptive="true"
   :clickToClose="false"
   >
   <div class="modalContainer">
      <div class="titlePage">
         Rol de Evaluación
      </div>
      <div class="tabcontent">
         <ValidationObserver ref="obsFieldsUpdate">
            <Formupdate
               :FieldsForm="formUpdate"
               :ModelForm="formUpdModel"
               :method="executeProcess"
               v-if="renderComponent2"
               />
         </ValidationObserver>
         <div class="modalActions">
            <div style="flex:1">
               <va-notification
                  color="danger"
                  v-if="existFlag"
                  class="refNoData"
                  >
                  Este rol no está disponible porque ya existe.
               </va-notification>
            </div>
            <button
               v-if="isNew === false"
               id="updateRol"
               class="loginbtn primaryBtn"
               @click="updateRol"
               >
            Actualizar
            </button>
            <button
               v-if="isNew === true"
               id="AddRol"
               class="loginbtn primaryBtn"
               @click="AddRol"
               >
            Guardar
            </button>
            <button
               id="CancelUser"
               class="loginbtn secondaryBtn"
               @click="CancelUser"
               >
            Cancelar
            </button>
         </div>
      </div>
   </div>
</modal>
      <div class="titlePage">
         Administración - Roles de Evaluación Docente
      </div>
      <va-notification color="info" v-if="addRExito" class="refNoData">
         Se creó correctamente el rol solicitado.
      </va-notification>
      <va-notification color="info" v-if="UpdRExito" class="refNoData">
         Se actualizó correctamente el rol solicitado.
      </va-notification>
      <va-notification color="danger" v-if="refNoUpdate" class="refNoData">
         La actualización del rol presentó un fallo.
      </va-notification>
      <va-notification color="danger" v-if="refWSUpdate" class="refNoData">
         El servicio que ejecuta la actualización no se encuentra activo.
      </va-notification>
      <va-notification
         color="danger"
         v-if="existFlag"
         class="refNoData d-flex justify-content-between"
         >
         <p>Este rol no está disponible porque ya existe.</p>
      </va-notification>
      <ValidationObserver ref="obsFieldsSearch">
         <FormSearch
            :FieldsForm="formSearch"
            :ModelForm="formSchModel"
            :method="executeProcess"
            />
      </ValidationObserver>
      <va-notification
         color="danger"
         id="refNoData"
         class="refNoData noShow"
         >
         No se encontró información del rol solicitado.
      </va-notification>
      <div class="listPrograms">
         <DataTable
            :InfoView="DLRol"
            :HeadTable="HDRol"
            :method="processData"
            v-if="renderComponent1"
            />
      </div>
   </div>
</template>
<script>
// eslint-disable-next-line import/no-duplicates
import FormSearch from '@/components/forms/Forms.vue'
import Formupdate from '@/components/forms/Forms.vue'
// eslint-disable-next-line import/no-duplicates
import IberoHelpers from '@/store/helpers.js'
// Data Table.
import DataTable from '@/components/data-tables/DataEvalRoles.vue'

export default {
    name: 'dataUpdate',
    components: {
        FormSearch,
        Formupdate,
        DataTable,
    },
    data() {
        return {
            formSchModel: {},
            formSearch: [
                {
                    id: 'Sch_Button',
                    type: 'button',
                    placeholder: 'Consultar Rol',
                    class: 'botonReff',
                },
                {
                    id: 'Sch_ButtonNew',
                    type: 'button',
                    placeholder: 'Crear Rol',
                    class: '',
                },
            ],
            formUpdModel: {
                id: '',
                idEval: '',
                rol: '',
                status: '',
            },

            formUpdate: [
                {
                    id: 'idEval',
                    model: 'idEval',
                    name: 'Tipo de formulario',
                    type: 'Select',
                    placeholder: 'Seleccione un rol',
                    values: [
                        { id: '1', value: 'Docente' },
                        { id: '2', value: 'Administrativo' },
                    ],
                    validate: {
                        required: true,
                    },
                    class: 'col-md-4',
                },
                {
                    id: 'rol',
                    model: 'rol',
                    name: 'rol',
                    type: 'input',
                    placeholder: 'rol',
                    validate: {
                        required: true,
                    },
                    class: 'col-md-4',
                },
                {
                    id: 'status',
                    model: 'status',
                    name: 'estado',
                    type: 'Select',
                    placeholder: 'Seleccione un estado',
                    values: [
                        { id: 'Activo', value: 'Activo' },
                        { id: 'Inactivo', value: 'Inactivo' },
                    ],
                    validate: {
                        required: true,
                    },
                    class: 'col-md-4',
                },
            ],

            HDRol: [
                {
                    name: 'id',
                    title: 'Id',
                    sortField: 'id',
                    width: '25%',
                },
                {
                    name: 'idEval',
                    title: 'id Formulario',
                    sortField: 'idEval',
                    width: '25%',
                },
                {
                    name: 'tipoEval',
                    title: 'tipo de Formulario',
                    sortField: 'id',
                    width: '25%',
                },
                {
                    name: 'rol',
                    title: 'rol',
                    sortField: 'status',
                    width: '30%',
                },
                {
                    name: 'status',
                    title: 'status',
                    sortField: 'price',
                    width: '30%',
                },
                {
                    name: '__slot:actions',
                    title: 'Acciones',
                    dataClass: 'text-center',
                    actionRef: [
                        {
                            label: 'Editar',
                            icon: 'fa-pencil',
                            action: 'edit',
                        },
                        {
                            label: 'Eliminar',
                            icon: 'equis',
                            action: 'inactivar',
                        },
                    ],
                },

            ],
            DLRol: [],
            renderComponent1: false,
            renderComponent2: false,
            addRExito: false,
            UpdRExito: false,
            refNoUpdate: false,
            refWSUpdate: false,
            existFlag: false,
            isNew: false,
        }
    },

    methods: {

        openModal() {
            this.$modal.show('RolModal')
        },
        closeModal() {
            this.$modal.hide('RolModal')
        },
        executeProcess: function (event, refer) {
            this.limpiaref()
            switch (event.target.id) {
                case 'btn_Sch_Button':
                    this.isNew = false
                    return new Promise((resolve, reject) => {
                        this.$refs.obsFieldsSearch.validate().then(results => {
                            if (!results) {
                                resolve(false)
                            } else {
                                this.searchForm()
                                resolve(true)
                            }
                        })
                    })
                case 'btn_Sch_ButtonNew':
                    this.limpiaref()
                    this.clearFields()
                    this.isNew = true
                    IberoHelpers.forceRerender2(this)
                    this.$modal.show('RolModal')
            }
            this.$refs.obsFieldsSearch.validate()
        },

        hideCard(card) {
            switch (card) {
                case 'creado':
                    setTimeout(() => {
                        this.addRExito = false
                    }, 5000);
                    break;
                case 'actualizado':
                    setTimeout(() => {
                        this.UpdRExito = false
                    }, 5000);
                    break;
                case 'actFallo':
                    setTimeout(() => {
                        this.refNoUpdate = false
                    }, 5000);
                    break;
                case 'noActivo':
                    setTimeout(() => {
                        this.refWSUpdate = false
                    }, 5000);

                    break;
                case 'existe':
                    setTimeout(() => {
                        this.existFlag = false
                    }, 5000);
                    break;
            }
        },

        searchForm() {
            document.getElementById('refNoData').classList.add('noShow')
            this.isNew = false
            let loader = this.$loading.show()
            var listRol = IberoHelpers.GetEvalRoles(this.$store, this.formSchModel, 0)
            this.renderComponent1 = false
            listRol.then(Response => {
                if ((Response.data === undefined) || (Response.data === '')) {
                    document.getElementById('refNoData').classList.remove('noShow')
                } else {
                    if (Array.isArray(Response.data)) {
                        for (let i = 0; i < Response.data.length; i++) {
                            if (Response.data[i].status === true) {
                                Response.data[i].status = 'Activo'
                            } if (Response.data[i].status === false) {
                                Response.data[i].status = 'Inactivo'
                            }
                        }
                        this.DLRol = Response.data
                    } else {
                        for (let i = 0; i < Response.data.length; i++) {
                            if ([Response.data[i]].status === true) {
                                [Response.data[i]].status = 'Activo'
                            } else if ([Response.data[i]].status === false) {
                                [Response.data[i]].status = 'Inactivo'
                            }
                        }
                        this.DLRol = [Response.data]
                    }
                    IberoHelpers.forceRerender1(this)
                }
                loader.hide()
            })
        },



        async checkData(tipoRol, rol) {

            let rr = document.getElementById('rol')
            let rLower = rr.value.toLowerCase()

            let existflag = false;
            this.existFlag = false;

            this.formUpdModel.rol = this.formUpdModel.rol.toLowerCase()

            const { data } = await IberoHelpers.GetEvalRoles(this.$store, this.formSchModel, 0)
            if (data.length > 0) {
                for (let i = 0; i < data.length; i++) {
                    if (data[i].idEval == tipoRol) {
                        if (data[i].rol == rLower) {
                            existflag = true
                            break;
                        }
                    }
                }
            }
            return existflag

        },

        async updateRol() {
                return new Promise((resolve, reject) => {
                    this.$refs.obsFieldsUpdate.validate().then(results => {
                        if (!results) {
                            resolve(false)
                        } else {
                            let loader = this.$loading.show()
                            var totalinf = IberoHelpers.EditEvalRoles(
                                this.$store,
                                this.formUpdModel
                            )
                            totalinf.then(Response => {
                                this.renderComponent1 = false
                                if (Response === false) {
                                    this.refWSUpdate = true
                                    this.hideCard('noActivo')
                                    resolve(false)
                                } else if (!(Response.status === 200)) {
                                    this.refNoUpdate = true
                                    this.hideCard('actFallo')
                                    resolve(false)
                                }else{
                                    this.UpdRExito = true
                                    this.hideCard('actualizado')
                                    resolve(true)
                                }
                                this.$modal.hide('RolModal')
                                this.searchForm()
                                loader.hide()
                            })

                        }
                    })
                })
        },

        async AddRol() {
            this.limpiaref()
            let ExistRol;
            ExistRol = await this.checkData(
                this.formUpdModel.idEval,
                this.formUpdModel.rol
            )

            if (ExistRol == false) {
                return new Promise((resolve, reject) => {
                    this.$refs.obsFieldsUpdate.validate().then(results => {
                        if (!results) {
                            resolve(false)
                        } else {
                            let loader = this.$loading.show()
                            var totalinf = IberoHelpers.AddEvalRoles(this.$store, this.formUpdModel)
                            totalinf.then(Response => {
                                this.renderComponent1 = false
                                if (Response === false) {
                                    this.refWSUpdate = true
                                    resolve(false)
                                } else if (!(Response.status === 200)) {
                                    this.refNoUpdate = true
                                    resolve(false)
                                } else if (ExistRol == false) {
                                    this.addRExito = true
                                    this.hideCard('creado')
                                }
                                this.$modal.hide('RolModal')
                                this.searchForm()
                                loader.hide()
                            })
                        }
                    })
                })
            } else {
                this.$modal.hide('RolModal')
                this.existFlag = true
                this.hideCard('existe')
                this.searchForm()
            }
        },

        /* 
        return new Promise((resolve, reject) => {
                this.$refs.obsFieldsUpdate.validate().then(results => {
                    if (!results) {
                        resolve(false)
                    } else {
                        let loader = this.$loading.show()


                        if (respuesta == false) {
                            var totalinf = IberoHelpers.AddEvalRoles(this.$store, this.formUpdModel)
                            totalinf.then(Response => {
                                this.renderComponent1 = false
                                if (Response === false) {
                                    this.refWSUpdate = true
                                    resolve(false)
                                } else if (!(Response.status === 200)) {
                                    this.refNoUpdate = true
                                    resolve(false)
                                }
                                this.$modal.hide('RolModal')
                                this.searchForm()
                                loader.hide()
                            })
                        }
                    }
                })
            })
        */

        CancelUser() {
            this.limpiaref()
            this.clearFields()
            this.$modal.hide('RolModal')
        },

        limpiaref() {
            this.addRExito = false
            this.UpdRExito = false
            this.refNoUpdate = false
            this.refWSUpdate = false
            document.getElementById('refNoData').classList.add('noShow')
        },
        clearFields() {
            this.formUpdModel.id = ''
            this.formUpdModel.idEval = ''
            this.formUpdModel.rol = ''
            this.formUpdModel.status = ''
        },

        processData: function (dataInf, refdata) {
            this.limpiaref()
            this.isNew = false
            this.formUpdModel.id = dataInf.id
            this.formUpdModel.idEval = dataInf.idEval
            this.formUpdModel.rol = dataInf.rol
            this.formUpdModel.status = dataInf.status
            IberoHelpers.forceRerender2(this)
            this.$modal.show('RolModal')
        },

    },
    mounted() {
        this.searchForm()
    },
}
</script>